// extracted by mini-css-extract-plugin
export default {"pageWrap":"og-z"};